import _ from 'lodash';
import { stringCompare } from '../utils/trainUtils';

export const Quotas = Object.freeze({
  GN: {
    code: 'GN',
    value: 'General',
  },
  LD: {
    code: 'LD',
    value: 'Ladies',
  },
  TQ: {
    code: 'TQ',
    value: 'Tatkal',
  },
  PT: {
    code: 'PT',
    value: 'Premium Tatkal',
  },
  SS: {
    code: 'SS',
    value: 'Lower Berth Quota',
  },
  HP: {
    code: 'HP',
    value: 'Physically Handicapped Quota',
  },
  HO: {
    code: 'HO',
    value: 'Headquarters/High official Quota',
  },
  PH: {
    code: 'PH',
    value: 'Parliament House Quota',
  },

});

export const isTatkalQuota = (selectedQuota) =>
  !_.isEmpty(selectedQuota) && stringCompare(selectedQuota.code, Quotas.TQ.code);

export const isLadiesQuota = (selectedQuota) =>
  !_.isEmpty(selectedQuota) && stringCompare(selectedQuota.code, Quotas.LD.code);

export const getQuotaType = (value) => Object.values(Quotas).find((quotaType) =>
  stringCompare(quotaType.code, value));
